import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  current_year: any = new Date().getFullYear();

  passwordFormDetails: any = {
    values: {
      email: '',
    },
    errors: {
      email: false,
    },
  };
  globalError: boolean = false;

  constructor(
    public commonService: CommonService,
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    // this.authService.logout();
  }

  validateInputFields(data, key, type) {
    this.globalError = false;
    if (data.values[key] !== '') {
      data.errors[key] = false;
      if (type === 'email') {
        if (
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(data.values[key])
        ) {
          data.errors[key] = false;
        } else {
          data.errors[key] = true;
        }
      }
    } else {
      data.errors[key] = true;
    }
  }

  validateForm(data) {
    let update = false;
    for (const value in data.values) {
      if (value === 'email') {
        this.validateInputFields(data, value, 'email');
      } else {
        this.validateInputFields(data, value, 'text');
      }

      update = data.values[value] !== '' ? true : false;
    }
    return update === true ? true : false;
  }

  button_loading_state: boolean = false;
  reset() {
    this.button_loading_state = true;
    if (this.validateForm(this.passwordFormDetails)) {
      this.globalError = false;
      const payload = {
        email: this.passwordFormDetails.values.email,
      };
      this.commonService
        .postData('/generate_forgotpasswordlink/', payload)
        .subscribe(
          (res: any) => {
            this.commonService.showToast(
              'success',
              'Forgot password email sent successfully',
            );
            this.router.navigate(['/login']);
            this.button_loading_state = true;
          },
          (err: ErrorEvent) => {
            this.globalError = true;
            this.button_loading_state = false;
          },
        );
    } else {
      this.button_loading_state = false;
    }
  }

  navigate(url) {
    this.router.navigate([url]);
  }
}
